import styled from '@emotion/styled';
import BackgroundLayer from '../layers/BackgroundLayer';
import HairBackLayer from '../layers/HairBackLayer';
import HeadLayer from '../layers/HeadLayer';
import EyesLayer from '../layers/EyesLayer';
import NoseLayer from '../layers/NoseLayer';
import MouthLayer from '../layers/MouthLayer';
import HairFrontLayer from '../layers/HairFrontLayer';
import AccessoryLayer from '../layers/AccessoryLayer';
import EarsLayer from '../layers/EarsLayer';
import FacialHairLayer from '../layers/FacialHairLayer';
import LogoLayer from '../layers/LogoLayer';
import { AccessoriesOverrideEarsList, AccessoriesOverrideEyesList, AccessoriesOverrideHairFrontList, AccessoriesOverrideHairList } from 'shared/types/optionSets';
import { ColorState, OptionState } from '../types';

interface Props {
  optionState: OptionState;
  colorState: ColorState;
}

const AvatarLayers = ({ optionState, colorState }: Props) => {
  return (
    <OuterContainer>
      <BackgroundLayer
        option={optionState.background}
        colorBase={colorState.background}
      />
      {!AccessoriesOverrideHairList.includes(optionState.accessories.headgear) && (
        <HairBackLayer
          option={optionState.hair}
          colorBase={colorState.hair}
        />
      )}
      <HeadLayer
        colorBase={colorState.skin}
      />
      {!AccessoriesOverrideEyesList.includes(optionState.accessories.eyewear) && (
        <EyesLayer
          option={optionState.eyes}
        />
      )}
      <NoseLayer
        option={optionState.nose}
      />
      <MouthLayer
        option={optionState.mouth}
        colorBase={colorState.mouth}
      />
      {(!AccessoriesOverrideHairList.includes(optionState.accessories.headgear) &&
        !AccessoriesOverrideHairFrontList.includes(optionState.accessories.headgear)) && (
        <HairFrontLayer
          option={optionState.hair}
          colorBase={colorState.hair}
        />
      )}
      <AccessoryLayer
        option={optionState.accessories.eyewear}
        colorBase={colorState.accessories.eyewear}
      />
      <AccessoryLayer
        option={optionState.accessories.headgear}
        colorBase={colorState.accessories.headgear}
      />
      <AccessoryLayer
        option={optionState.accessories.fanfetti}
        colorBase={colorState.accessories.fanfetti}
      />
      {!AccessoriesOverrideEarsList.includes(optionState.accessories.eyewear || optionState.accessories.headgear) && (
        <EarsLayer
          option={optionState.ears}
          colorBase={colorState.skin}
        />
      )}
      <FacialHairLayer
        option={optionState.facialHair}
        colorBase={colorState.hair}
      />
      <LogoLayer
        option={optionState.logo}
      />
      {/* Achievements disabled in first version */}
      {/* <AchievementsLayer
        option={optionState.achievements}
      /> */}
    </OuterContainer>
  );
}

export default AvatarLayers;

const OuterContainer = styled.div({
  flex: 1,
});
